import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import {
  ExportStudentsWorkloadAchievementUseCaseInterface,
  GetStudentsWorkloadAchievementUseCaseInterface,
} from 'domain/usecases';

export class RemoteGetStudentsWorkloadAchievement
  implements GetStudentsWorkloadAchievementUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetStudentsWorkloadAchievementUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetStudentsWorkloadAchievementUseCaseInterface.Params,
  ): Promise<GetStudentsWorkloadAchievementUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, params),
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}

export class RemoteExportStudentsWorkloadAchievement
  implements ExportStudentsWorkloadAchievementUseCaseInterface
{
  constructor(
    private readonly pdfUrl: string,
    private readonly excelUrl: string,
    private readonly httpClient: HttpClient<ExportStudentsWorkloadAchievementUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportStudentsWorkloadAchievementUseCaseInterface.Params,
  ): Promise<ExportStudentsWorkloadAchievementUseCaseInterface.Result> {
    const { type, ...restParams } = params;
    const requestUrl = generateUrl(
      type === 'pdf' ? this.pdfUrl : this.excelUrl,
      restParams,
    );

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
